<template>
  <div>
    <el-card>
      <div style="margin-bottom: 15px">
        <el-button type="primary" @click="handleAdd">新增广告</el-button>
      </div>
      <el-table :data="list" border stripe v-loading="loading">
        <el-table-column prop="id" label="ID" width="80"></el-table-column>
        <el-table-column prop="title" label="标题" width="150"></el-table-column>
        <el-table-column label="图片" width="120">
          <template slot-scope="{ row }">
            <el-image :src="row.imageUrl" style="width: 80px; height: 50px" fit="cover"></el-image>
          </template>
        </el-table-column>
        <el-table-column prop="linkUrl" label="链接" min-width="180" show-overflow-tooltip></el-table-column>
        <el-table-column prop="sortOrder" label="排序" width="80"></el-table-column>
        <el-table-column label="状态" width="80">
          <template slot-scope="{ row }">
            <el-tag :type="row.enabled === 1 ? 'success' : 'info'" size="small">
              {{ row.enabled === 1 ? '启用' : '禁用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="160"></el-table-column>
        <el-table-column label="操作" width="150">
          <template slot-scope="{ row }">
            <el-button type="text" @click="handleEdit(row)">编辑</el-button>
            <el-button type="text" style="color: #F56C6C" @click="handleDelete(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        style="margin-top: 20px; text-align: right"
        :current-page="query.page"
        :page-sizes="[10, 20, 50]"
        :page-size="query.pageSize"
        :total="total"
        layout="total, sizes, prev, pager, next"
        @size-change="val => { query.pageSize = val; fetchList() }"
        @current-change="val => { query.page = val; fetchList() }"
      ></el-pagination>
    </el-card>

    <el-dialog :title="isEdit ? '编辑广告' : '新增广告'" :visible.sync="dialogVisible" width="500px">
      <el-form ref="form" :model="form" :rules="rules" label-width="80px">
        <el-form-item label="展示位置" prop="positionCode">
          <el-select v-model="form.positionCode" placeholder="请选择展示位置" style="width: 100%">
            <el-option label="首页轮播" value="HOME_BANNER"></el-option>
            <el-option label="分类页轮播" value="CATEGORY_BANNER"></el-option>
            <el-option label="详情页广告" value="DETAIL_BANNER"></el-option>
            <el-option label="其他位置" value="OTHER_BANNER"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="标题" prop="title">
          <el-input v-model="form.title"></el-input>
        </el-form-item>
        <el-form-item label="广告图片" prop="imageUrl">
          <div style="display: flex; align-items: flex-start; gap: 12px">
            <el-upload
              class="banner-upload"
              :action="uploadAction"
              :headers="uploadHeaders"
              :show-file-list="false"
              :before-upload="beforeUpload"
              :on-success="handleUploadSuccess"
              :on-error="handleUploadError"
              accept="image/*"
              style="display: inline-block"
            >
              <el-button size="small" type="primary" :loading="uploading">选择图片</el-button>
              <div slot="tip" style="font-size: 12px; color: #909399; margin-top: 4px">建议尺寸 750x350，支持 jpg/png</div>
            </el-upload>
            <div v-if="form.imageUrl" class="banner-preview">
              <el-image :src="form.imageUrl" style="width: 120px; height: 60px" fit="cover"></el-image>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="链接">
          <el-input v-model="form.linkUrl" placeholder="请输入跳转链接"></el-input>
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="form.sortOrder" :min="0"></el-input-number>
        </el-form-item>
        <el-form-item label="状态">
          <el-switch v-model="form.enabled" :active-value="1" :inactive-value="0" active-text="启用" inactive-text="禁用"></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSubmit">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getBanners, addBanner, updateBanner, deleteBanner, uploadFile } from '../../api'
import { getToken } from '../../utils/auth'

export default {
  name: 'BannerManage',
  data() {
    return {
      query: { page: 1, pageSize: 10 },
      list: [], total: 0, loading: false,
      dialogVisible: false, isEdit: false, uploading: false,
      form: { id: null, title: '', positionCode: 'HOME_BANNER', imageUrl: '', jumpType: 'NONE', linkUrl: '', sortOrder: 0, enabled: 1 },
      rules: { title: [{ required: true, message: '请输入标题', trigger: 'blur' }], imageUrl: [{ required: true, message: '请上传广告图片', trigger: 'change' }], positionCode: [{ required: true, message: '请选择展示位置', trigger: 'change' }] }
    }
  },
  computed: {
    uploadAction() {
      return process.env.VUE_APP_BASE_API ? process.env.VUE_APP_BASE_API + '/api/admin/files/upload' : '/api/admin/files/upload'
    },
    uploadHeaders() {
      return { access_token: getToken() }
    }
  },
  created() { this.fetchList() },
  methods: {
    fetchList() {
      this.loading = true
      getBanners(this.query).then(res => {
        this.list = res.data.records || res.data || []
        this.total = res.data.total || 0
      }).finally(() => { this.loading = false })
    },
    handleAdd() {
      this.isEdit = false
      this.form = { id: null, title: '', positionCode: 'HOME_BANNER', imageUrl: '', jumpType: 'NONE', linkUrl: '', sortOrder: 0, enabled: 1 }
      this.$nextTick(() => { if (this.$refs.form) this.$refs.form.clearValidate() })
      this.dialogVisible = true
    },
    handleEdit(row) {
      this.isEdit = true
      this.form = {
        ...row,
        linkUrl: row.jumpValue || row.linkUrl || ''
      }
      this.$nextTick(() => { if (this.$refs.form) this.$refs.form.clearValidate() })
      this.dialogVisible = true
    },
    beforeUpload(file) {
      const isImage = file.type.startsWith('image/')
      if (!isImage) {
        this.$message.error('只能上传图片文件')
        return false
      }
      const isLt5M = file.size / 1024 / 1024 < 5
      if (!isLt5M) {
        this.$message.error('图片大小不能超过 5MB')
        return false
      }
      this.uploading = true
      return true
    },
    handleUploadSuccess(res) {
      this.uploading = false
      if (res.code === 200 && res.data && res.data.url) {
        this.form.imageUrl = res.data.url
        this.$message.success('上传成功')
      } else {
        this.$message.error(res.msg || '上传失败')
      }
    },
    handleUploadError() {
      this.uploading = false
      this.$message.error('上传失败，请重试')
    },
    handleSubmit() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        const fn = this.isEdit ? updateBanner(this.form.id, this.form) : addBanner(this.form)
        fn.then(() => {
          this.$message.success(this.isEdit ? '修改成功' : '新增成功')
          this.dialogVisible = false
          this.fetchList()
        })
      })
    },
    handleDelete(row) {
      this.$confirm('确定要删除该广告吗？', '提示', { type: 'warning' }).then(() => {
        deleteBanner(row.id).then(() => { this.$message.success('已删除'); this.fetchList() })
      }).catch(() => {})
    }
  }
}
</script>
